import XEndpoints from "../../core/config/Endpoints";
import XApi from "../../utils/Api";

export class AccountService {
    // Expenses
    async addExpense(data: any) {
        const token = localStorage.getItem("token");
        if (token) {
            const response = await XApi.post(XEndpoints.expense, data, {
                "Content-Type": "application/json",
                Authorization: token,
            });
            return response ?? null;
        }
        return null;
    }

    async updateExpense(id: number, data: any) {
        const token = localStorage.getItem("token");
        if (token) {
            const response = await XApi.patch(
                `${XEndpoints.expense}/detail/${id}`,
                data,
                {
                    "Content-Type": "application/json",
                    Authorization: token,
                }
            );
            return response ?? null;
        }
        return null;
    }

    async getExpense(id: number) {
        const token = localStorage.getItem("token");
        if (token) {
            const response = await XApi.get(`${XEndpoints.expense}/detail/${id}`, {
                "Content-Type": "application/json",
                Authorization: token,
            });
            return response ?? null;
        }
        return null;
    }

    async exportExpense(data: any) {
        const token = localStorage.getItem('token');
        if (token) {
            const response = await XApi.post(`${XEndpoints.expense}/export`, data, {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            });
            return response ?? null;
        }
        return null;
    }

    // Vouchers
    async addVoucher(data: any) {
        const token = localStorage.getItem("token");
        if (token) {
            const response = await XApi.post(XEndpoints.voucher, data, {
                "Content-Type": "application/json",
                Authorization: token,
            });
            return response ?? null;
        }
        return null;
    }

    async updateVoucher(id: number, data: any) {
        const token = localStorage.getItem("token");
        if (token) {
            const response = await XApi.patch(
                `${XEndpoints.voucher}/detail/${id}`,
                data,
                {
                    "Content-Type": "application/json",
                    Authorization: token,
                }
            );
            return response ?? null;
        }
        return null;
    }

    async getVoucher(id: number) {
        const token = localStorage.getItem("token");
        if (token) {
            const response = await XApi.get(`${XEndpoints.voucher}/detail/${id}`, {
                "Content-Type": "application/json",
                Authorization: token,
            });
            return response ?? null;
        }
        return null;
    }

    async exportVourcher(data: any, type: string) {
        const token = localStorage.getItem('token');
        if (token) {
            const response = await XApi.post(`${XEndpoints.voucher}/export/${type}`, data, {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            });
            return response ?? null;
        }
        return null;
    }

    async getVoucherNumber(type: string) {
        const token = localStorage.getItem("token");
        if (token) {
            const response = await XApi.get(`${XEndpoints.voucher}/number/${type}`, {
                "Content-Type": "application/json",
                Authorization: token,
            });
            return response ?? null;
        }
        return null;
    }
}
